<template>
    <div class="p-4 border-2 border-solid border-secondary-100">
        <div class="flex flex-wrap mb-4 -mx-2">
            <!-- <labeled-input
                v-model="localValue.firstName"
                class="flex-1"
                :name="`${type}[firstName]`"
                label="First name"
                required
            /> -->

            <LabeledInput
                v-model="localValue.fullName"
                class="flex-1"
                :name="`${type}[fullName]`"
                label="Full name"
                required
            />
        </div>

        <LabeledInput
            v-model="localValue.addressLine1"
            class="mb-4 px-0"
            :name="`${type}[addressLine1]`"
            label="Address 1"
            autocomplete="address-line1"
            required
        />

        <LabeledInput
            v-model="localValue.addressLine2"
            class="mb-4 px-0"
            :name="`${type}[addressLine2]`"
            label="Address 2"
            autocomplete="address-line2"
        />

        <div class="flex flex-wrap mb-4 -mx-2">
            <LabeledInput
                v-model="localValue.locality"
                class="flex-1"
                :name="`${type}[locality]`"
                label="City"
                autocomplete="address-level2"
                required
            />

            <LabeledInput
                v-model="localValue.postalCode"
                class="flex-1"
                :name="`${type}[postalCode]`"
                label="Post code"
                autocomplete="postal-code"
                required
            />
        </div>

        <div class="flex flex-wrap -mx-2">
            <LabeledDropdown
                v-model="localValue.countryCode"
                class="flex-1 px-2"
                :name="`${type}[countryCode]`"
                label="Countries"
                :options="countries"
                required
            />

            <LabeledDropdown
                v-if="country && country.states.length > 0"
                v-model="localValue.administrativeArea"
                class="flex-1 px-2"
                :name="`${type}[administrativeArea]`"
                label="State"
                :options="country.states"
                required
            />
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import LabeledDropdown from '../LabeledDropdown.vue';
import LabeledInput from '../LabeledInput.vue';
const { mapState } = createNamespacedHelpers('cart');

export default {
    components: {
        LabeledDropdown,
        LabeledInput,
    },

    props: {
        type: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Object,
            required: true,
        },
    },

    emits: ['update:modelValue'],

    computed: {
        ...mapState([
            'countries',
        ]),

        localValue: {
            get() {
                return this.modelValue;
            },
            set(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },

        id() {
            return `${this.type}-new`;
        },

        country() {
            return this.countries.find((country) => { return country.value === this.modelValue.countryCode; });
        },
    },
};
</script>
